<script lang="ts" setup>
import useMarkdown from '@/home/hooks/markdown';

const marked = useMarkdown();
</script>

<template>
  <section class="page-about-description mt-80">
    <div class="container border border-#9A9EA6/10 rounded-4 border-solid bg-white px-64 py-48 text-justify shadow-[0px_0px_16px_0px_rgba(0,0,0,0.04)] <md:py-32 <sm:px-16 <xl:px-24">
      <h2 class="m-0 text-center text-32 font-medium <md:text-26">{{ $t('about.title') }}</h2>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="mt-32" v-html="marked.parse($t('about.infoAbout.introduction'))">
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-about-description {
  &:deep(p) {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    text-indent: 2em;
  }
}
</style>
